import { message } from "antd";
import { useMutation, useQueryClient } from "react-query";
import sliderApi from "../../../../api/sliderApi";
import SliderList from "../../../../components/SliderList";
import PageWrap from "../../../../layout/PageWrap";
import { messages } from "../../../../utils/messages";

const ListSlideHome = () => {
  const queryClient = useQueryClient();
  const mutation = useMutation(sliderApi.deleteHomeSlider, {
    onSuccess: (data: any) => {
      if (data.statusCode === 200) {
        message.success(messages.deleteSuccess);
        queryClient.invalidateQueries("home-slider");
      } else {
        message.error(data?.data?.message ?? messages.error);
      }
    },
    onError: (err: any) => {
      message.error(err?.data?.message ?? messages.error);
    },
  });

  return (
    <PageWrap
      title="Slidershow chính"
      content={
        <SliderList
          headContent="Slidershow chính"
          handleRemove={(e) => mutation.mutate(e)}
          keyQuery="home-slider"
          link="/slider/home"
          action={useMutation(sliderApi.updateVisibleHome, {
            onSuccess: (data: any) => {
              if (data.statusCode === 200) {
                message.success(messages.updateSuccess);
                queryClient.invalidateQueries("home-slider");
              } else {
                message.error(data?.data?.message ?? messages.error);
              }
            },
            onError: (err: any) => {
              message.error(err?.data?.message ?? messages.error);
            },
          })}
          query={sliderApi.getHomeSlider}
          column={[
            {
              title: "Hình ảnh",
              dataIndex: "photo",
              key: "photo",
              width: "20%",
              className: "td-slider-picture",
              render: (record: string) => {
                return (
                  <img
                    src={`${process.env.REACT_APP_DOMAIN}${record}`}
                    alt=""
                    className="slider-picture"
                  ></img>
                );
              },
            },
            {
              title: "Link",
              dataIndex: "url",
              key: "url",
              width: "40%",
              render: (record: string) => {
                return (
                  <a target="_blank" rel="noreferrer" href={record}>
                    {record}
                  </a>
                );
              },
            },
          ]}
        />
      }
    />
  );
};

export default ListSlideHome;
